<template>
  <div class='d-flex align-center justify-space-between' style='height: 72px'>
    <div class='d-flex align-center ml-8'>
      <v-img style='margin-right: 14px' :src="require('@/assets/images/avatars/cssa_bot.png')"
             width='25'
             alt=''></v-img>
      <div>
        <span class='font-weight-bold black--text' style='font-size: 20px'>CSSA</span>
      </div>
    </div>
    <div>
      <feedback-menu></feedback-menu>
      <v-icon
        v-if='isOpsSuperAdmin'
        class='mr-4 cursor-pointer'
        :color="adminCogEnter ? '#7f26d3' : '#100d1b'"
        @mouseenter='adminCogEnter = !adminCogEnter'
        @mouseleave='adminCogEnter = !adminCogEnter'
        @click="$router.push({path: 'management/query'})"
      >{{ icons.mdiCogOutline }}
      </v-icon>
    </div>
  </div>
</template>
<script>
import { getLookUpByClassifyCodeV2 } from '@/modules/chat/api/index'
import { store } from '@/myops/core'
import { mdiCogOutline } from '@mdi/js'
import FeedbackMenu from '@/modules/chat/view/chatbot/component/FeedbackMenu'

export default {
  components: {
    FeedbackMenu,
  },
  data() {
    return {
      icons: {
        mdiCogOutline,
      },
      adminCogEnter: false,
      adminEidList: [],
    }
  },
  computed: {
    firstName() {
      return store.state.user.user.userExInfo.sapPersonalInfo.firstName || store.state.user.user.eid
    },
    isOpsSuperAdmin() {
      return this.adminEidList.includes(store.state.user.user.eid)
    },
  },
  async created() {
    const {
      data: {
        code,
        data,
      },
    } = await getLookUpByClassifyCodeV2({ classifyCode: 'CSSA_ADMIN' })
    if (code === 200) {
      this.adminEidList = data.map(item => item.value)
    }
  },
}
</script>
